import { createActionsHook } from 'src/lib/sweetState';

import { GenerationStore } from './GenerationStore';

export const useGenerationActions = createActionsHook(GenerationStore);
